/* eslint-disable no-unused-vars */
import consumer from './consumer';
import { get } from '@rails/request.js';
import { admin_notifications_path } from '../../javascript/routes';

let retryCount = 0;
const maxRetries = 3;
const retryInterval = 3000;

consumer.subscriptions.create('NotificationsChannel', {
  connected() {
    retryCount = 0;
  },

  disconnected() {
    this.reconnect();
  },

  received(data) {
    const currentUserId = document.querySelector('meta[name="current-user-id"]')?.getAttribute('content');

    if (data.recipient_id !== currentUserId) {
      this.updateNotificationsCount(data.unread_count);
      this.updateNotificationsList();
    }
  },

  getNotificationController() {
    const element = document.querySelector('[data-controller~="notification--component"]');
    if (element) {
      return element.controller('notification--component');
    }
    return null;
  },

  async updateNotificationsCount(unread_count) {
    try {
      const countElements = document.querySelectorAll('[data-notification--component-target="count"]');
      countElements.forEach((element) => {
        element.textContent = unread_count;
      });
    } catch (_) {
      // console.error('Error fetching unread count:', error);
    }
  },

  async updateNotificationsList() {
    const notificationsContainer = document.querySelector('#notifications_lazy_loading');
    if (notificationsContainer) {
      try {
        await get(admin_notifications_path(), {
          responseKind: 'turbo-stream',
        });
      } catch (error) {
        console.error('Error updating notifications list:', error);
      }
    }
  },

  reconnect() {
    if (retryCount < maxRetries) {
      retryCount++;
      setTimeout(() => {
        consumer.subscriptions.create('NotificationsChannel', this);
      }, retryInterval);
    }
  },
});
